/* ================================================================
   GIDO — Order Orchestration v1
   State management, zip validation, Shopify Cart API integration.
   Loaded synchronously by gido-lunch-plan section.
   ================================================================ */

'use strict';

window.GidoOrder = (function () {

  /* ── State ────────────────────────────────────────────────── */
  var state = {
    planVariantId: null,
    planPrice:     0,
    planTitle:     '',
    addons:        {},   // key → { id, price, title, qty }
    zip:           '',
    zipValid:      false,
  };

  /* ── Valid Houston Metro Zip Codes ────────────────────────── */
  var VALID_ZIPS = new Set([
    // Core Houston (77001–77099)
    '77001','77002','77003','77004','77005','77006','77007','77008','77009','77010',
    '77011','77012','77013','77014','77016','77017','77018','77019','77020',
    '77021','77022','77023','77024','77025','77026','77027','77028','77030',
    '77031','77032','77033','77034','77035','77036','77037','77038','77039','77040',
    '77041','77042','77043','77045','77046','77047','77048','77050',
    '77051','77052','77053','77054','77055','77056','77057','77058','77059','77060','77061',
    '77062','77063','77064','77065','77066','77067','77068','77069','77070','77071',
    '77072','77073','77074','77075','77076','77077','77078','77079','77080','77081',
    '77082','77083','77084','77085','77086','77087','77088','77089','77090','77091',
    '77092','77093','77094','77095','77096','77097','77098','77099',
    // Bellaire
    '77401',
    // Richmond
    '77406','77407','77469',
    // Fulshear
    '77423','77441',
    // Cypress
    '77429','77433',
    // Katy
    '77449','77450','77493','77494',
    // Missouri City
    '77459','77489',
    // Stafford / Sugar Land
    '77477','77478','77479','77496','77498',
    // Spring
    '77373','77379','77388'
  ]);

  /* ── Helpers ──────────────────────────────────────────────── */
  function emit(name, detail) {
    document.dispatchEvent(
      new CustomEvent('gido:' + name, { detail: detail || {}, bubbles: true })
    );
  }

  function formatMoney(cents) {
    var n = cents / 100;
    return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }

  function getTotal() {
    var total = state.planPrice;
    Object.keys(state.addons).forEach(function (k) {
      total += state.addons[k].price * state.addons[k].qty;
    });
    return total;
  }

  function getStateCopy() {
    return JSON.parse(JSON.stringify(state));
  }

  /* ── Public API ───────────────────────────────────────────── */
  function setPlan(variantId, price, title) {
    state.planVariantId = variantId;
    state.planPrice     = price;
    state.planTitle     = title;
    emit('price-updated', { total: getTotal(), state: getStateCopy() });
  }

  function setAddon(key, variantId, price, title, qty) {
    if (variantId) {
      state.addons[key] = { id: variantId, price: price, title: title, qty: qty || 1 };
    } else {
      delete state.addons[key];
    }
    emit('price-updated', { total: getTotal(), state: getStateCopy() });
  }

  function validateZip(zip) {
    var clean     = (zip || '').trim().replace(/\D/g, '');
    state.zip     = clean.slice(0, 5);
    state.zipValid = clean.length === 5 && VALID_ZIPS.has(clean);
    return state.zipValid;
  }

  function isZipValid() { return state.zipValid; }

  function addToCart(onSuccess, onError) {
    var items = [];

    if (state.planVariantId) {
      items.push({ id: Number(state.planVariantId), quantity: 1 });
    }
    Object.keys(state.addons).forEach(function (k) {
      var a = state.addons[k];
      items.push({ id: Number(a.id), quantity: a.qty });
    });

    if (!items.length) {
      onError && onError('Please select a plan to continue.');
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (d) {
            throw new Error(d.description || 'Could not add to cart.');
          });
        }
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            emit('cart-updated', { count: cart.item_count });
            onSuccess && onSuccess();
          });
      })
      .catch(function (err) { onError && onError(err.message || 'Something went wrong.'); });
  }

  return {
    setPlan:     setPlan,
    setAddon:    setAddon,
    getTotal:    getTotal,
    validateZip: validateZip,
    isZipValid:  isZipValid,
    addToCart:   addToCart,
    formatMoney: formatMoney,
    getState:    getStateCopy,
  };

})();
